import {Component, EventEmitter, Input, NgZone, Output, ViewChild} from '@angular/core';
import {CheckboxChangeEventDetail, IonCheckbox, IonToggle, ToggleChangeEventDetail} from '@ionic/angular';
import {AbstractNgModelComponent} from '../ng-model.component';

@Component({template: ''})
// @ts-ignore
export abstract class IonToggleBaseComponent extends AbstractNgModelComponent<any> implements IonToggle {

  @Input() checked: boolean = false;
  @Input() color: any;

  @Input() mode: 'ios' | 'md' = 'md';
  @Input() name: string;

  @Input() enableOnOffLabels: boolean | undefined;

  @Output() ionBlur: EventEmitter<CustomEvent<void>> = new EventEmitter<CustomEvent<void>>();
  @Output() ionChange: EventEmitter<CustomEvent<ToggleChangeEventDetail>> = new EventEmitter<CustomEvent<ToggleChangeEventDetail>>();
  @Output() ionFocus: EventEmitter<CustomEvent<void>> = new EventEmitter<CustomEvent<void>>();

  protected el: HTMLElement;
  protected z: NgZone;

  onBlur(event: CustomEvent<void> | any) {
    this.ionBlur.emit(event);
  }

  onFocus(event: CustomEvent<void> | any) {
    this.ionFocus.emit(event);
  }

}
